/**
 * Encoding helpers shared by the client and the in-memory mock. Browser +
 * Node ≥ 19 both expose `btoa`/`atob`, `globalThis.crypto.randomUUID`, and
 * WebCrypto `subtle` — no Node-only `Buffer` dependency, so this runs unchanged
 * in a Vite bundle and in vitest.
 */
/** Bytes → standard padded base64. */
export function toBase64(bytes) {
    let bin = '';
    for (let i = 0; i < bytes.length; i += 1) {
        bin += String.fromCharCode(bytes[i]);
    }
    return btoa(bin);
}
/** Standard base64 → bytes. */
export function fromBase64(b64) {
    const bin = atob(b64);
    const out = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i += 1) {
        out[i] = bin.charCodeAt(i);
    }
    return out;
}
/** Fresh v4 UUID (client-generated entity id). */
export function uuidv4() {
    return crypto.randomUUID();
}
/** Canonical UUID string → its 16 raw bytes (for crypto AAD binding). */
export function uuidToBytes(uuid) {
    const hex = uuid.replace(/-/g, '');
    if (hex.length !== 32 || /[^0-9a-fA-F]/u.test(hex)) {
        throw new Error('invalid uuid');
    }
    const out = new Uint8Array(16);
    for (let i = 0; i < 16; i += 1) {
        out[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
    }
    return out;
}
const enc = new TextEncoder();
/** UTF-8 encode. */
export function utf8(s) {
    return enc.encode(s);
}
/**
 * Copy a `Uint8Array` into a fresh, exclusively-owned `ArrayBuffer`. WebCrypto
 * (TS 5.7 dom lib) demands `BufferSource` backed by `ArrayBuffer`, not the
 * generic `ArrayBufferLike` (which admits `SharedArrayBuffer`) — so we copy.
 */
export function toArrayBuffer(u) {
    const ab = new ArrayBuffer(u.byteLength);
    new Uint8Array(ab).set(u);
    return ab;
}
/** SHA-256 digest via WebCrypto. */
export async function sha256(data) {
    const digest = await crypto.subtle.digest('SHA-256', toArrayBuffer(data));
    return new Uint8Array(digest);
}
//# sourceMappingURL=base64.js.map